import type { BroadcastGroupSummary } from '@/types/broadcast';

export const getGroupStatus = (group: BroadcastGroupSummary): string => group.status || 'pending';

export const getGroupTotalSent = (group: BroadcastGroupSummary): number => group.total_sent || 0;

export const getGroupSuccessRate = (group: BroadcastGroupSummary): number => group.success_rate || 0;

export const getGroupScheduledAt = (group: BroadcastGroupSummary): string | undefined =>
    group.scheduled_at ?? undefined;

export const sortGroupBroadcasts = (
    groups: BroadcastGroupSummary[],
    sortBy: 'created_at' | 'total_sent' | 'success_rate',
    sortOrder: 'asc' | 'desc'
): BroadcastGroupSummary[] => {
    return [...groups].sort((a, b) => {
        let comparison = 0;
        switch (sortBy) {
            case 'total_sent':
                comparison = getGroupTotalSent(a) - getGroupTotalSent(b);
                break;
            case 'success_rate':
                comparison = getGroupSuccessRate(a) - getGroupSuccessRate(b);
                break;
            case 'created_at': {
                const aDate = a.created_at || 0;
                const bDate = b.created_at || 0;
                comparison = new Date(aDate).getTime() - new Date(bDate).getTime();
                if (comparison === 0) comparison = a.group_broadcast_id - b.group_broadcast_id;
                break;
            }
        }
        return sortOrder === 'asc' ? comparison : -comparison;
    });
};

export const filterGroupBroadcasts = (
    groups: BroadcastGroupSummary[],
    filters: { status?: string; page?: string; category?: string }
): BroadcastGroupSummary[] => {
    return groups.filter(g => {
        if (filters.status && getGroupStatus(g) !== filters.status) return false;

        if (filters.page) {
            const usesPage = g.pages?.some(p => String(p.page_id) === String(filters.page));
            if (!usesPage) return false;
        }

        return true;
    });
};
